import { render, staticRenderFns } from "./discountInfo.vue?vue&type=template&id=14fba390"
import script from "./discountInfo.vue?vue&type=script&lang=js"
export * from "./discountInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports